import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import { SmoothScroll } from "./components/SmoothScroll";
import { Nav } from "./components/Nav";
import { Hero } from "./components/Hero";
import { Marquee } from "./components/Marquee";
import { Services } from "./components/Services";
import { Process } from "./components/Process";
import { About } from "./components/About";
import { Faq } from "./components/Faq";
import { QuoteSection } from "./components/QuoteSection";
import { Footer } from "./components/Footer";
import AdminPage from "./pages/AdminPage";

const Landing = () => (
  <>
    <SmoothScroll />
    <Nav />
    <main>
      <Hero />
      <Marquee />
      <Services />
      <Process />
      <About />
      <QuoteSection />
      <Faq />
    </main>
    <Footer />
  </>
);

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/admin" element={<AdminPage />} />
          <Route path="*" element={<Landing />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-center" richColors />
    </div>
  );
}

export default App;
